import React, { useMemo, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import SweetAlert from 'react-bootstrap-sweetalert'
import { FaSearch } from 'react-icons/fa'
import PbUmkuService from '../../../../services/pbumku/PbumkuService'

const ModalViewLaporan = ({ showViewLaporan, handleCloseViewLaporan, rowData, laporanFile, reloadList }) => {

    const [showConfirmApprove, setShowConfirmApprove] = useState(false)
    const handleCloseConfirmApprove = () => setShowConfirmApprove(false)
    const [showApproveSuccess, setShowApproveSuccess] = useState(false)
    const [showApproveFailed, setShowApproveFailed] = useState(false)

    let pbUmkuService = useMemo(() => new PbUmkuService(), [])

    const ApproveLaporan = () => {
        setShowConfirmApprove(true)
    }

    const handleClickApprove = async () => {
        try {
            let oldData = await pbUmkuService.findLaporanHeaderById(rowData.idLapHdr)
            let jsonLap = {
                idlaphdr: rowData.idLapHdr,
                idoss: rowData.idoss,
                idpryk: rowData.idpryk,
                idchecklist: rowData.idchecklist,
                idspt: rowData.idSpt,
                nib: rowData.nib,
                statusLap: "100",
                createdBy: oldData.data.createdBy,
                createdDate: oldData.data.createdDate,
                updatedBy: localStorage.getItem("userId"),
                updatedDate: new Date()
            }
            const _resLapHdr = await pbUmkuService.editLaporanHeader(jsonLap)
            if (_resLapHdr.data.kode === '200') {
                setShowApproveSuccess(true)
                setShowConfirmApprove(false)
            } else {
                setShowApproveFailed(true)
                setShowConfirmApprove(false)
            }
        } catch (error) {
            console.log(error)
            setShowApproveFailed(true)
        }
    }

    const handleClickApproveSuccess = () => {
        setShowApproveSuccess(false)
        handleCloseViewLaporan()
        reloadList(0, 10)
    }

    const handleClickApproveFailed = () => {
        setShowApproveFailed(false)
    }

    const downloadLaporanFile = () => {
        downloadExcelFromBase64(laporanFile.fileContent, laporanFile.fileNama)
    }

    return (
        <>
            <Modal show={showViewLaporan} onHide={handleCloseViewLaporan} backdrop='static' keyboard={false} scrollable={true} size='xl' centered>
                <Modal.Header>View Laporan Checklist</Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Perizinan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.urIzin} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">NIB / Nama Perusahaan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && (rowData.nib + ' / ' + rowData.namaPerseroan)} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor / Tanggal Permohonan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="idIzin" defaultValue={rowData !== null && rowData.idIzin + ' / ' + rowData.tglPermohonan} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor Kegiatan Usaha</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_proyek" defaultValue={rowData !== null && rowData.nomorProyek} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Usaha</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.uraianUsaha} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor / Tanggal SPT</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.nomorSpt + ' / ' + rowData.tanggalSpt} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Laporan Checklist</label>
                        <div className="col">
                            <Button variant="primary" size="sm" onClick={() => downloadLaporanFile()} ><FaSearch />{' '} Lihat Laporan</Button>{' '}
                            <label className="col-sm-4 col-form-label-sm">{laporanFile !== null ? laporanFile.fileNama : ''}</label>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Total Ketidaksesuaian</strong></label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-1 col-form-label-sm">Sesuai</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="sesuai" defaultValue={laporanFile !== null ? laporanFile.totalSesuai : ''} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Minor</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="minor" defaultValue={laporanFile !== null ? laporanFile.totalMinor : ''} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Mayor</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="mayor" defaultValue={laporanFile !== null ? laporanFile.totalMayor : ''} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Kritis</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="kritis" defaultValue={laporanFile !== null ? laporanFile.totalKritis : ''} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Hasil / Nilai Kuantitaif</strong></label>
                        <div className="col-sm-3">
                            <input type="text" className="col-sm-12 form-control-sm" name="hasil" defaultValue={laporanFile !== null ? laporanFile.totalHasil : ''} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Keterangan</label>
                        <div className="col-sm-3">
                            <input type="text" className="col-sm-12 form-control-sm" name="keterangan" defaultValue={laporanFile !== null ? laporanFile.keterangan : ''} disabled />
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {(localStorage.getItem("role") === "1" || localStorage.getItem("role") === "6") && (rowData !== null && rowData.statusLap === '000') &&
                        <Button variant="primary" size="sm" onClick={() => ApproveLaporan()} >Setuju</Button>
                    }{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseViewLaporan}>
                        Tutup
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmApprove &&
                <SweetAlert
                    title="Setujui Laporan?"
                    warning
                    showCancel
                    confirmBtnText="Setuju"
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    reverseButtons={true}
                    btnSize="sm"
                    onConfirm={handleClickApprove}
                    onCancel={handleCloseConfirmApprove}
                />
            }
            {
                showApproveSuccess &&
                <SweetAlert
                    title="Laporan Berhasil Disetujui"
                    success
                    onConfirm={handleClickApproveSuccess}
                    btnSize="sm"
                />
            }
            {
                showApproveFailed &&
                <SweetAlert
                    title="Laporan Gagal Disetujui"
                    danger
                    onConfirm={handleClickApproveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

function downloadExcelFromBase64(base64Data, fileName = 'file.xlsx') {
    // Decode the Base64 string
    const binaryData = atob(base64Data);

    // Convert binary string to ArrayBuffer
    const len = binaryData.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob with the appropriate MIME type for Excel
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Create a link element
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    // Programmatically click the link to trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up the link element
    document.body.removeChild(link);
}

export default ModalViewLaporan